import React, { PropsWithChildren, useContext } from "react";
import { hideWhenClosed } from "../../utils/hide-when-closed/hideWhenClosed";
import { FloatingPanelMenuContext } from "./FloatingPanelMenu.context";
import { IFloatingPanelMenuContentProps } from "./interfaces/IFloatingPanelMenuContentProps";
import { IFloatingPanelMenuItem } from "./interfaces/IFloatingPanelMenuItem";
import "./styles/floating-panel-menu-content.css";

export const FloatingPanelMenuContent = <T extends IFloatingPanelMenuItem = IFloatingPanelMenuItem>(
    props: PropsWithChildren<IFloatingPanelMenuContentProps<T>>
): React.JSX.Element => {
    const floatingPanelContext = useContext(FloatingPanelMenuContext);

    if (floatingPanelContext === undefined) {
        throw new Error("Can't use FloatingPanelMenuContent component outside of FloatingPanelMenu component.");
    }

    const { model, events, contentId } = floatingPanelContext;

    return (
        <ul
            style={hideWhenClosed(model.isOpen)}
            aria-activedescendant={`${contentId}-${model.activeItemIndex}`}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledBy}
            className={`cui-floating-panel-menu__list ${props.className !== undefined ? props.className : ""}`}
            data-hook={props.dataHook}
            id={contentId}
            ref={floatingPanelContext.menuRef}
            role="menu"
            tabIndex={-1}>
            {floatingPanelContext.items.map((item, i) => props.renderer(floatingPanelContext.model, item as T, i, contentId, events.trigger.onClick))}
        </ul>
    );
};
